// ─── Service « Lieux » (porté de MoPCal) ──────────────────────────
// Lieux réutilisables, stockés DANS le doc calendrier :
//   calendriers/{calId}.lieux = [{ id, nom, adresse, lat?, lng? }]
// Couvert par les règles d'écriture existantes du doc calendrier — aucun
// nouveau déploiement de règles Firestore requis.
import { db } from '@mop/core';
import { doc, setDoc, onSnapshot } from 'firebase/firestore';

// Identifiant local (sous-objet d'array : pas besoin d'un id Firestore).
export function nouveauLieuId() {
  return `lieu-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
}

// Écoute EN DIRECT les lieux du calendrier (le MÊME doc que l'écriture) → cohérence
// garantie même si ce calId n'est pas dans la liste des calendriers du contexte
// (ex. doc « espace pur » calendriers/{espaceId}). Renvoie une fonction de désabonnement.
export function ecouterLieux(calId, cb) {
  if (!calId) { cb([]); return () => {}; }
  return onSnapshot(
    doc(db, 'calendriers', calId),
    (s) => cb((s.exists() && Array.isArray(s.data().lieux)) ? s.data().lieux : []),
    () => cb([]),
  );
}

// Écrit la liste complète des lieux d'un calendrier (merge).
export async function enregistrerLieux(calId, lieux) {
  if (!calId) return;
  await setDoc(doc(db, 'calendriers', calId), { lieux: lieux || [] }, { merge: true });
}

// Normalise un lieu (trim + champs sûrs) ; conserve lat/lng si présents.
export function normaliserLieu(l) {
  const out = {
    id: l.id || nouveauLieuId(),
    nom: (l.nom || '').trim(),
    adresse: (l.adresse || '').trim(),
  };
  const lat = typeof l.lat === 'number' ? l.lat : parseFloat(l.lat);
  const lng = typeof l.lng === 'number' ? l.lng : parseFloat(l.lng);
  if (!Number.isNaN(lat) && !Number.isNaN(lng)) { out.lat = lat; out.lng = lng; }
  return out;
}
